import {CanActivateFn} from '@angular/router';

export const TemplateManagementGuard: CanActivateFn = () => {
  return localStorage.getItem('gp_template_management_enabled') === 'true';
};
